<script>
import { api } from '../../../firebase'
import ImageTemplatePreview from '../image-templates/ImageTemplatePreview'

export default {
  name: 'AdPreview',
  components: {
    ImageTemplatePreview
  },
  props: {
    event: { type: Object, required: true },
    imageTemplate: { type: Object, required: true },
    textTemplate: { type: Object, required: true },
    adCreativeSettings: { type: Object, required: true }
  },
  computed: {
    hasRenderedText() {
      return !!this.text.rendered
    },
    hasError() {
      return !!this.text.error
    },
    isPending() {
      return !this.hasRenderedText && !this.hasError
    }
  },
  data() {
    return {
      text: {
        rendered: null,
        error: null
      }
    }
  },
  async mounted() {
    try {
      const response = await api.textTemplates.render({
        textTemplate: this.textTemplate.id,
        event: this.event.id
      })
      this.text.rendered = response
    } catch (error) {
      this.text.error = error
    }
  }
}
</script>

<template>
  <v-simple-table>
    <template v-slot:default>
      <tbody>
        <tr>
          <td>Text template</td>
          <td>
            <router-link :to="'/mobilizev2/text-templates/' + textTemplate.id">{{ textTemplate.id }}</router-link>
          </td>
        </tr>
        <tr>
          <td>Image template</td>
          <td>
            <router-link :to="'/mobilizev2/image-templates/' + imageTemplate.id">{{ imageTemplate.id }}</router-link>
          </td>
        </tr>
        <tr>
          <td>Headline</td>
          <td>
            {{ isPending ? 'Loading...' : hasError ? 'An error occurred.' : text.rendered.headline }}
          </td>
        </tr>
        <tr>
          <td>Body</td>
          <td>
            {{ isPending ? 'Loading...' : hasError ? 'An error occurred.' : text.rendered.body }}
          </td>
        </tr>
        <tr>
          <td>Link description</td>
          <td>
            {{ isPending ? 'Loading...' : hasError ? 'An error occurred.' : text.rendered.linkDescription }}
          </td>
        </tr>
        <tr>
          <td>Image Preview</td>
          <td>
            <image-template-preview
              v-if="!adCreativeSettings.useEventImage"
              :image-template="imageTemplate.id"
              :event="event.id"
            />
            <div v-else>
              <img class="featuredImage" :src="event.data.featured_image_url" />
            </div>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<style scoped>
.featuredImage {
  max-height: 300px;
  max-width: 100%;
}
</style>
